import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ActivityTypologyStyle, appRoutes } from '@tekman/onmat/constants';
import { SessionEvaluationInstrument, SessionTask, StepActivity } from '@tekman/onmat/models';
import { UserService } from '@tekman/onmat/service/generic';
import { CategoryMapperService, FeaturitWrapperService } from '@tekman/onmat/service/onmat';
import { FeaturitEventActivity } from '@tekman/shared/models';
import { CloneUtility } from '@tekman/shared/utils';

@Component({
  selector: 'task-dropdowm',
  templateUrl: './task-dropdown.component.html',
  styleUrls: ['./task-dropdown.component.scss'],
})
export class TaskDropdownComponent {
  _activity: SessionTask[];
  @Input() set activity(value: SessionTask[]) {
    this._activity = value;
    const index = this._activity.findIndex(act => {
      return act.activity['solutionaryUrl'];
    });
    if (index > 0) {
      const deepClone = CloneUtility.deepClone(this._activity[index]);
      this._activity.push(deepClone);
      this._activity[this._activity.length - 1].activity.resourceUrl = '';
      this._activity[this._activity.length - 1].order = this._activity.length;
      this._activity[index].activity.solutionaryUrl = '';
    }
  }
  @Input() stepId: string;
  @Input() stepTitle: string;
  @Input() disabled: boolean;
  isTeacher: boolean = this.userService.isTeacher();
  tipologyStyle: typeof ActivityTypologyStyle = ActivityTypologyStyle;

  constructor(
    public readonly categoryMapperService: CategoryMapperService,
    private readonly _router: Router,
    private readonly userService: UserService,
    private readonly featuritService: FeaturitWrapperService
  ) {}

  handleClickStep(activity: StepActivity, disabled: boolean): void {
    if (disabled) return;
    if (activity.resourceUrl) {
      this.track(activity, 'itineraries');
      window.open(activity.resourceUrl, '_blank');
      return;
    }
    if (activity.solutionaryUrl) {
      this.track(activity, 'itineraries');
      window.open(activity.solutionaryUrl, '_blank');
      return;
    }
    this._router.navigate([appRoutes.activities, activity.id, 'exercise']);
  }

  track(currentActivity: StepActivity | SessionEvaluationInstrument, ui_path: string) {
    const trackingProps: FeaturitEventActivity<string> = new FeaturitEventActivity({
      ui_path: ui_path,
      step_id: this.stepId,
      step_title: this.stepTitle,
      activity_id: currentActivity?.id,
      activity_title: currentActivity?.title,
      activity_typology: this.categoryMapperService.getCategory(currentActivity?.typologyStyle),
      activity_subtypology: currentActivity?.typologyStyle,
    });
    this.featuritService.track(this.featuritService.eventKeys.activityDownload, trackingProps);
  }

  isTypeOfActivity(
    activity: StepActivity | SessionEvaluationInstrument | Array<SessionEvaluationInstrument> | Array<StepActivity>
  ): boolean {
    return !Array.isArray(activity);
  }

  protected readonly ActivityTypologyStyle = ActivityTypologyStyle;
}
